<header
  class="header"
  [class.full-width]="!isSidebarVisible">
  <div class="left">
    <ng-container *featureFlag="'displayEnvironment'">
      <div class="environment">
        <mat-icon>{{ currentEnvironment.icon }}</mat-icon>
        <div class="environment-name">
          <p class="bold">{{ currentEnvironment.type }}</p>
          @if (currentEnvironment['featurePrefix']) {
            <p class="bold">{{ currentEnvironment['featurePrefix] }}</p>
          }
        </div>
      </div>
    </ng-container>
  </div>
  @if ((isSearchVisible$ | async) && (isLoggedInAsUser$ | async)) {
    <div
      #searchContainer
      class="search">
      <coin-icon-button
        class="text mobile-search-button"
        icon="search"
        type="outline"
        [attr.aria-label]="'header.search.open' | translate"
        (click)="toggleSearch()"></coin-icon-button>
      <div
        class="search-bar-container"
        [class.mobile-visible]="isSearchBarVisibleOnMobile$ | async"
        [class.full-width]="!isSidebarVisible">
        <coin-group-search-bar
          #searchBar
          resultCacheKey="recentCosmosSearchResults"
          class="search-input"
          [searchResultGroups]="searchResultGroups"></coin-group-search-bar>
      </div>
    </div>
  }

  <div class="right">
    @if (updateNotifications.hasUpdates()) {
      <coin-update-notifier></coin-update-notifier>
    }
    <cosmos-user-menu class="user-menu"></cosmos-user-menu>
    <cosmos-help-menu class="help"></cosmos-help-menu>
  </div>
</header>
